import React, { useEffect, useState } from "react";
import { faMapMarkerAlt, faStickyNote } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Icon, Modal } from "antd";
import LeafletModal from "../../components/map/LeafletModal";
import Mispichoshelper from "../../utils/Mispichoshelper";


function ShowTagState({ state }) {
  var rowEstado = "";
  console.log("ESTADO DE LA COMPRA", state)
  if (state === "cancelado") {
    rowEstado = "Cancelado"
  } else if (state === "con problemas") {
    rowEstado = "Informado a MisPichos"
  } else if (state === "completado" || state === "entregado") {
    rowEstado = "Entregado"
  } else if (state === "preparando") {
    rowEstado = "Pendiente de entregar"
  } else if (state === "procesando") {
    rowEstado = "Pendiente de aceptar"
  } else {
    rowEstado = state
  }

  return (
    <span className="Tag">{rowEstado}</span>
  )
}

function Address({ state }) {
  var florAndDpto = null
  if (state.estado !== "procesando") {
    florAndDpto = state.floor + ' ' + state.dpto;
  }
  if (state.estadoId === 1) {
    return <p style={{ fontWeight: 'normal' }}>{(state.distancia / 1000).toFixed(2)} km del cliente, {state.dir_barrio}</p>
  }
  return <p style={{ fontWeight: 'normal' }}>{state.dir_barrio + ', ' + state.dir_calle} {florAndDpto}</p>

}


function etiquetarBonus(str) {
  let result = str;
  result = result.replace("bonus", `<span style="background: #f0ff00;padding: 3px;border-radius: 12px;">Pack</span>`)
  result = result.replace("kilo gramos regalo", `<span style="background: #f0ff00;padding: 3px;border-radius: 12px;">Bonus Bag</span>`);
  result = result.replace("regalo", `<span style="background: #f0ff00;padding: 3px;border-radius: 12px;">Con Regalo</span>`);
  return result;
}


function Products({ state }) {
  if (state) {
    return state.productos.map((producto, iproducto) =>
      <div key={iproducto} className='ListaPedidoItem'>
        <img src={producto.src} alt="Logo" />
        {producto.type === "Alimento Balanceado" ?
          <p><b>{producto.quantity + 'x'}</b>
            <div dangerouslySetInnerHTML={{ __html: etiquetarBonus(producto.nombre_completo_con_unidad) }}></div><b> {'$' + ((producto?.quantity && producto?.price) ? (producto.quantity * producto.price) : producto.total_amount)} </b></p>
          :
          <p><b>{producto.quantity + 'x'}</b><div>{' ' + producto.nombre_sin_variacion} <strong>Presentación:</strong>{' ' + producto.variation}</div> <b> {'$' + ((producto?.quantity && producto?.price) ? (producto.quantity * producto.price) : producto.total_amount)} </b> </p>
        }
      </div>
    )
  }
}


function Notes({ state }) {
  const [visible, setVisible] = useState();
  const [extraNOtes, setExtraNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Mispichoshelper.Petshop.getNotes({ 'com_id': state.key }).then(response => {
      setExtraNotes(response.payload)
      setLoading(false)
    });
  }, []);

  if (loading) return (
    <p style={{ textAligne: 'center' }}>
      Cargando notas <Icon type="loading" />
    </p>
  )

  return (
    <>
      {state.nota && state.nota !== "" &&
        <div className='BorderAnimatedByOmi'>
          <h5>Nota del cliente: </h5>
          <h6>{state.nota}</h6>
        </div>
      }
      {extraNOtes.map((cada_nt) =>
        <div className='BorderAnimatedByOmi'>
          <p>Fecha y hora: {cada_nt.date}</p>
          <h5>Nota de Mis Pichos: </h5>
          <h6>{cada_nt.value}</h6>
        </div>
      )}
    </>
  )

}

function PaymentInfo({ state }) {
  const [visible, setVisible] = useState();
  const [infoPaymentClient, setInfoPaymentClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Mispichoshelper.Petshop.getClientPayment({ com_id: state.num }).then(response => {
      setInfoPaymentClient(response.payload.data)
      setLoading(false)
    });
  }, []);

  if (loading) return (
    <p style={{ textAligne: 'center' }}>
      Cargando información <Icon type="loading" />
    </p>
  )

  return (
    <div>
      <div className='MT1'>Nombre En Tarjeta: {infoPaymentClient.card_holder_name}</div>
      <div className='MT1'>DNI Tarjeta: {infoPaymentClient.card_holder_identification}</div>
    </div>
  )

}

function showDateOrder(orderSelected) {
  var fechaPedido = new Date(orderSelected.fecha_pura + 'T00:00:00');
  if (orderSelected.com_fecha === "HOY" || orderSelected.com_fecha === "MAÑANA") {
    return orderSelected.com_fecha + ' ' + fechaPedido.getDate() + '/' + (fechaPedido.getMonth() + 1);
  } else {
    return orderSelected.com_fecha;
  }
}


function OrderInfo({ showMap, orderSelected, changeShowMap, loading, rotatedElement, order }) {
  if (loading) {
    console.log("entro en loading")
    return <div className='PopUpLoading'><Icon type="loading" /></div>;
  } else if (rotatedElement) {
    return null;
  }
  let total_descuento = orderSelected.discount + orderSelected.credito
  var cantProductos = 0;
  orderSelected && orderSelected.productos.map((eachProduct) => cantProductos += eachProduct.quantity);
  return (
    <div>
      {order === "pedidoSorteo" && <div className='NuevaOportunidad'>Nueva Oportunidad</div>}
      <article className="Card jaulaCen">
        <div className="RowCenter SpaceBetween">
          <div>
            <div className="RowCenter">
              <strong>{'#' + orderSelected.key}</strong>
              <ShowTagState state={orderSelected.estado} />
            </div>
            <Address state={orderSelected} />
          </div>
          <FontAwesomeIcon
            className="PopUpIconMap"
            icon={faMapMarkerAlt}
            onClick={() => changeShowMap()}
          />
        </div>

        <div className="P1 Franja FranjaCeleste">
          {showDateOrder(orderSelected)} de {orderSelected.rango_horario + " hs."}
        </div>

        <div className="Franja">
          Pedido con <strong>{cantProductos}</strong> productos.
        </div>

        <div className={`ListaPedidos ${orderSelected.productos.length >= 5 ? 'new-scrollbar' : ''}`}>
          {<Products state={orderSelected} />}
        </div>

        <Notes state={orderSelected} />

        <div className="Franja FranjaNormal RowCenter SpaceBetween">
          <div className="">
            {orderSelected.total_descuento_petshop ? <span style={{ background: 'green', color: 'white', padding: 5, borderRadius: 12, margin: 5 }}>La Fábrica te paga + ${orderSelected.total_descuento_petshop}</span> : ""}
            <br />
          </div>
          {orderSelected.estado !== "procesando" ?
            <div className="">
              <strong>Subtotal: $</strong> {orderSelected.subtotal}<br />
              {total_descuento > 0 ? <><span style={{ backgroundColor: 'green', color: 'white', padding: '2px 5px', borderRadius: 12 }}>Descuento a cargo de MisPichos: -${total_descuento}</span> <br /></> : null}
              <strong>Total a cobrar del cliente: $</strong> {orderSelected.total_full}
            </div>
            :
            <div className="">
              <strong>Total: $</strong> {orderSelected.subtotal}<br />

            </div>
          }
        </div>


        {showMap &&
          <LeafletModal
            id={"mapPopUp"}
            lat={orderSelected.clienteCoordenadas.lat}
            lng={orderSelected.clienteCoordenadas.lng}
            changeShowMap={changeShowMap}
            marker={orderSelected.estadoId !== 1 ? true : false}
            circle={orderSelected.estadoId === 1 ? true : false}
          />}
      </article>
    </div>
  )
}

export default OrderInfo;
export { Address, Products, Notes, ShowTagState, PaymentInfo }
